<template>
  <b-row align-h="center">
    <b-col v-if="noResult" md="10" lg="8" xl="6">
      <div class="noresult align-items-center justify-content-center">
        <img
          src="https://cdn.vexels.com/img/search-woman.png"
          :alt="$t('withoutResult.main.wildcard.seekerManAlt')"
          loading="lazy"
        />
        <div class="text-container">
          <p v-if="inSortPage">
            {{ $t('withoutResult.main.noResult.noMatchFound') }}
          </p>
          <p v-else>
            {{ $t('withoutResult.main.noResult.notFoundTextBefore') }}
            <span style="color: #000000">"{{ actualSearch }}"</span>
            {{ $t('withoutResult.main.noResult.notFoundTextAfter') }}
          </p>
        </div>
      </div>

      <div class="make-request-block">
        <div class="column">
          <h1 class="title">
            {{ $t('withoutResult.main.makeRequest.cantFindIt') }} <br />
            <span class="blue">{{ $t('withoutResult.main.makeRequest.weWillMake') }}</span>
          </h1>
          <p class="description">{{ $t('withoutResult.main.makeRequest.description') }}</p>
        </div>
        <div class="column btn-container d-flex align-items-center">
          <Button
            shape="full"
            color="green"
            size="big"
            :to="requestLink"
            @click="$ga.event('All Listings', 'Click No Results Request Button', $route.fullPath)"
          >
            <Icon class="mr-1" :width="25" :height="25" color="white" icon="design-requests" />
            {{ requestText }}
          </Button>
        </div>
      </div>

      <FindBestDesignsBlocks />
      <BestCategories />
    </b-col>
  </b-row>
</template>

<script>
import FindBestDesignsBlocks from '@/components/Common/FindBestDesignsBlocks';
import BestCategories from '@/components/Common/BestCategories';
import Button from 'UI/Button';
import Icon from 'UI/Icon';
export default {
  components: {
    FindBestDesignsBlocks,
    BestCategories,
    Button,
    Icon
  },
  props: {
    inSortPage: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    actualSearch() {
      return this.$route.params.search ? this.$route.params.search.replace(/-/g, ' ') : '';
    },
    noResult() {
      return (
        this.$store.state.search.searchResult.length == 0 && !this.$store.state.search.searching
      );
    },
    requestLink() {
      const link = this.$auth.loggedIn
        ? this.localePath('profile-my-requests-new')
        : this.$urlBuilder('landing', { uid: 'design-requests' });
      return link;
    },
    requestText() {
      return this.$auth.loggedIn
        ? this.$t('withoutResult.main.makeRequest.request')
        : this.$t('withoutResult.main.makeRequest.learnMore');
    }
  }
};
</script>

<style lang="scss" scoped>
.noresult {
  margin: auto;
  transition: 0.5s width;
  display: flex;
}
.noresult img {
  width: 40%;
}
.noresult .text-container {
  width: 48%;
  padding-left: 50px;
}
.noresult .text-container p {
  font-size: 30px;
  color: #989898;
}
.noresult .text-container p a {
  color: #3cd699;
}
.vx-btn {
  border-radius: 50px;
  height: max-content;
  margin: auto;
}
.make-request-block {
  display: flex;
  width: 100%;
  background: transparent linear-gradient(80deg, #f8f8f8 0%, #ffffff 100%) 0% 0% no-repeat
    padding-box;
  border: 3px solid $lightestGray;
  border-radius: 9px;
  padding: 70px 8%;
  margin: 70px auto;
  transition: padding 0.5s;
}
.make-request-block > .column {
  width: 50%;
}
.make-request-block > .column.btn-container {
  justify-content: right;
}
.make-request-block > .column > .title {
  font-size: 40px;
  color: #787878;
}
.make-request-block > .column > .title > span.blue {
  color: #3f80f1;
}
.make-request-block > .column > .description {
  color: #6e6e6e;
  margin-top: 40px;
  font-size: 16px;
}
@media all and (max-width: 1650px) {
  .make-request-block {
    padding: 50px 8%;
    display: block;
  }
  .make-request-block > .column {
    width: 100%;
  }
  .make-request-block > .column.btn-container {
    margin-top: 50px;
    justify-content: center;
  }
}
@media all and (max-width: 1500px) {
  .make-request-block {
    padding: 50px 8%;
  }
  .make-request-block > .column > .title {
    font-size: 30px;
  }
}
@media all and (max-width: $screen-sm-min) {
  .noresult .text-container {
    padding: 0 0 0 50px;
  }
  .noresult .text-container p {
    font-size: 25px;
  }
}
@media all and (max-width: $screen-lg-min) {
  .noresult .text-container p {
    font-size: 20px;
  }
}
@media all and (max-width: $screen-md-min) {
  .noresult {
    display: block;
    text-align: center;
  }
  .noresult .text-container {
    padding: 0;
    margin: auto;
    margin-top: 25px;
    text-align: left;
  }
  .make-request-block {
    padding: 70px;
    width: 100%;
  }
}
@media all and (max-width: $screen-sm-min) {
  .noresult .text-container {
    width: 95%;
  }
  .noresult img {
    width: 60%;
  }
}
@media all and (max-width: $screen-xs-min) {
  .noresult img {
    width: 90%;
  }
  .make-request-block {
    padding: 20px;
    width: 100%;
  }
}
</style>
